module.exports = __webpack_public_path__ + "img/header_bg.b5a64be5.png";